import { render } from "./ReviewStarRating.vue?vue&type=template&id=8c145192&scoped=true"
import script from "./ReviewStarRating.vue?vue&type=script&lang=js"
export * from "./ReviewStarRating.vue?vue&type=script&lang=js"

import "./ReviewStarRating.vue?vue&type=style&index=0&id=8c145192&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c145192"]])

export default __exports__